import React, {useCallback, useState} from 'react';
import 'react-modal-video/scss/modal-video.scss';
import faqData from "../../data/faqData";

const CLASS_NAMES = {
    ACTIVE: 'active',
    ACTIVE_BLOCK: 'active-block',
    CURRENT: 'current',
};
function Block6() {

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = useCallback((index) => {
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    }, []);


    return (
            <section className="faqs-section" style={{background: "#F5F9FE", display : "none"}}>
                <div className="auto-container">
                    <div className="homepage-titre poppins mb-1">Exemples de questions <span>fréquemment posées</span>
                    </div>

                    <div className="text mt-30">
                        La FAQ personnalisée de la hotline Handicap est conçue pour <span>répondre spécifiquement aux besoins et interrogations de vos collaborateurs,</span>
                        tout en tenant compte de <span>votre politique d’inclusion et des particularités de votre entreprise.</span>
                        Ce format intuitif permet d’anticiper les questions courantes et de fournir <span>des réponses claires et adaptées,</span>
                        renforçant ainsi la confiance et l’autonomie des équipes.
                        Voici ci-dessous des exemples de questions fréquemment posées :
                    </div>

                    <ul className="accordion-box">
                        {faqData.map((item, index) => (
                                <li
                                        key={index}
                                        className={`accordion block ${
                                                activeIndex === index ? CLASS_NAMES.ACTIVE_BLOCK : ''
                                        }`}
                                >
                                    <div
                                            className={`acc-btn ${
                                                    activeIndex === index ? CLASS_NAMES.ACTIVE : ''
                                            }`}
                                            onClick={() => handleClick(index)}
                                    >
                                        {item.question}
                                        <span className="icon flaticon-add"></span>
                                    </div>
                                    <div
                                            className={`acc-content ${
                                                    activeIndex === index ? CLASS_NAMES.CURRENT : ''
                                            }`}
                                    >
                                        <div className="content">
                                            <p>{item.answer}</p>
                                        </div>
                                    </div>
                                </li>
                        ))}
                    </ul>
                </div>
            </section>
    )
}

export default Block6;
